import { SERVICE_OTA_UPDATE } from "../define";
import axios from "axios";
import { ESP32BLEBluetooth } from "..";
import { toHex } from "@/utils/math";
import { isOnTest } from "@/utils/env";
import { CapacitorHttp } from "@capacitor/core";
import { isWeb } from "@/utils/capacitor";

const files = [
  "fuxi_ble.py",
  "fuxi_config.py",
  "fuxi_main.py",
  "fuxi_uart.py",
  "fuxi_uart_at_command.py",
  "main.py",
  "canfd_message_0x596.mpy",
  "micropython.bin", // 固件
];

export const bufferFiles = [
  // 二进制文件
  "canfd_message_0x596.mpy",
  "micropython.bin",
];

export const firmwareFiles = ["micropython.bin"];

// 请求文件
const request = async (fileName: string) => {
  let res: any;
  if (isWeb) {
    res = await axios.get(
      `${"https://tool-cec.chehejia.com/"}/xcu-ble-download/${fileName}`,
      {
        responseType: bufferFiles.includes(fileName) ? "arraybuffer" : "text",
      }
    );
  } else {
    const data = {
      url: `${"https://tool-cec.chehejia.com/"}/xcu-ble-download/${fileName}`,
      responseType: bufferFiles.includes(fileName) ? "arraybuffer" : "text",
    } as any;
    res = await CapacitorHttp.get(data);
    // 如果是二进制文件，确保返回 ArrayBuffer
    if (bufferFiles.includes(fileName) && res.data) {
      // 如果返回的是 base64 字符串，转换为 ArrayBuffer
      if (typeof res.data === "string") {
        const binaryString = atob(res.data);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
      }
    }
  }
  return res.data;
};

// 获取更新文件列表
export const fetchUpdateFileList = async () => {
  const fileList = await Promise.all(
    files.map(async (fileName) => {
      const data = await request(fileName);
      // console.log("[BOWEN_LOG] 🚀 ~~ 请求线上文件 ~~ data:", { data });
      return {
        file_name: fileName,
        file_content: data,
      } as DomianControl.UpdateFileItem;
    })
  );
  console.log("[BOWEN_LOG] 🚀 ~~ 请求线上文件 ~~ fileList:", fileList);
  return fileList;
};

// 设备升级重置
export const UPDATE_RSET = {
  name: "UPDATE_RSET",
  uuid: 0x6301,
  properties: ["read", "write", "notify"],
};
// 上传MD5信息和读取 MD5
export const UPLOAD_MD5 = {
  name: "UPLOAD_MD5",
  uuid: 0x6401,
  properties: ["read", "write", "notify"],
};
// 上传文件内容
export const UPLOAD_FILE = {
  name: "UPLOAD_FILE",
  uuid: 0x6501,
  properties: ["read", "write", "notify"],
};
// 上传固件
export const UPLOAD_FIRMWARE = {
  name: "UPLOAD_FIRMWARE",
  uuid: 0x6201,
  properties: ["read", "write", "notify"],
};
// 查看是否允许刷写固件
export const CHECK_FIRMWARE = {
  name: "CHECK_FIRMWARE",
  uuid: 0x6001,
  properties: ["read", "write", "notify"],
};
// 返回出厂设置
export const RESET_FACTORY = {
  name: "RESET_FACTORY",
  uuid: 0x6101,
  properties: ["read", "write", "notify"],
};

//  更新上传软件文件 string
export const uploadSoftware = async (data: any) => writeData(data, UPLOAD_FILE);
//  更新上传软件文件 ArrayBuffer
export const uploadSoftwareBuffer = async (data: any) =>
  writeDataBuffer(data, UPLOAD_FILE);

// 更新上传固件 ArrayBuffer
export const uploadFirmware = async (data: any) =>
  writeDataBuffer(data, UPLOAD_FIRMWARE);

export const uploadFileMD5 = async (data: any) => writeDataCompress(data, UPLOAD_MD5); // 上传 md5
export const readFileMD5 = async () => readData(UPLOAD_MD5); // 获取esp32 md5
export const updateReset = async () => writeData("1", UPDATE_RSET); // 更新固件
export const checkFirmware = async () => readData(CHECK_FIRMWARE); // 是否允许更新固件
export const resetFactory = async () => writeData("1", RESET_FACTORY); // 重启

export async function readData(uuidData = UPDATE_RSET) {
  console.log(
    "[BOWEN_LOG] 🚀 ESP32Update ~~ readData ~~ data:",
    uuidData.name,
    toHex(uuidData.uuid)
  );
  try {
    const value = await ESP32BLEBluetooth.queuePerformReadData(
      SERVICE_OTA_UPDATE.uuid,
      uuidData.uuid,
      { notShowNotify: true }
    );
    if (value) return value as any;
    return null;
  } catch (error) {
    console.error("[API] readData Error:", error);
  }
}
// 写入数据 字符串 不压缩
export async function writeData(data: any, uuidData = UPDATE_RSET) {
  console.log(
    "[BOWEN_LOG] 🚀 ESP32Update ~~ writeData ~~ data:",
    uuidData.name,
    toHex(uuidData.uuid),
    data
  );
  try {
    const res = await ESP32BLEBluetooth.queuePerformWriteData(
      data,
      SERVICE_OTA_UPDATE.uuid,
      uuidData.uuid,
      { notCompress: true }
    );
    return res;
  } catch (error) {
    console.error("[API] ESP32Update writeData Error:", error);
  }
}
// 压缩写入 字符串
export async function writeDataCompress(data: any, uuidData = UPDATE_RSET) {
  console.log(
    "[BOWEN_LOG] 🚀 ESP32Update ~~ writeDataCompress ~~ data:",
    uuidData.name,
    toHex(uuidData.uuid),
    data
  );
  try {
    const res = await ESP32BLEBluetooth.queuePerformWriteData(
      data,
      SERVICE_OTA_UPDATE.uuid,
      uuidData.uuid
    );
    return res;
  } catch (error) {
    console.error("[API] ESP32Update writeData Error:", error);
  }
}
// 写入数据 ArrayBuffer
export async function writeDataBuffer(data: any, uuidData = UPDATE_RSET) {
  console.log(
    "[BOWEN_LOG] 🚀 ESP32Update ~~ writeDataBuffer ~~ data:",
    uuidData.name,
    toHex(uuidData.uuid),
    data
  );
  try {
    const res = await ESP32BLEBluetooth.queuePerformWriteData(
      data,
      SERVICE_OTA_UPDATE.uuid,
      uuidData.uuid,
      { showRawRes: true }
    );
    return res;
  } catch (error) {
    console.error("[API] ESP32Update writeData Error:", error);
  }
}

// export const getFirmware = async () => {
//   const fileName = "micropython.bin";
//   const res = await axios.get(
//     `https://tool-xqdev2.cec.lixiangoa.com/xcu-ble-download/${fileName}`,
//     {
//       responseType: "text",
//     }
//   );
//   return {
//     file_name: fileName,
//     file_content: res.data,
//   } as DomianControl.UpdateFileItem;
// };
